import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addPackage = catchAsync(async (locationId, body) => {
  const data = await axiosInstance.post(`salon/${locationId}/packages`, body);
  return data;
});
export const packageDetails = catchAsync(
  async (locationId, packageId, xTranslate = false) => {
    const data = await axiosInstance.get(
      `salon/${locationId}/packages/${packageId}`,
      {
        headers: {
          "x-translations": xTranslate,
        },
      }
    );
    return data;
  }
);
export const getAllPackages = catchAsync(async (locationId, params) => {
  const { data } = await axiosInstance.get(`salon/${locationId}/packages`, {
    params,
  });
  return data;
});
export const getAllPackagesWithCategories = catchAsync(
  async (locationId, params) => {
    const { data } = await axiosInstance.get(
      `salon/${locationId}/categories-packages`,
      { params }
    );
    return data;
  }
);

export const updatePackage = catchAsync(async (locationId, packageId, body) => {
  const { data } = await axiosInstance.put(
    `salon/${locationId}/packages/${packageId}`,
    body
  );
  return data;
});
export const deletePackage = catchAsync(async ({ locationId, packageId }) => {
  const { data } = await axiosInstance.delete(
    `salon/${locationId}/packages/${packageId}`
  );
  return data;
});
export const getPackagesCategories = catchAsync(async () => {
  const { data } = await axiosInstance.get(`salon/package-categories`);
  return data;
});

//! the below apis maybe  not used
export const calculateRetailPrice = async (
  nonDiscountedPrice,
  priceType,
  percentageDiscount = null
) => {
  const params = {
    non_discounted_price: nonDiscountedPrice,
    price_type: priceType,
  };

  if (percentageDiscount !== null) {
    params.percentageDiscount = percentageDiscount;
  }

  const { data } = await axiosInstance.get("/salon/calculate-retail-price", {
    params: params,
  });

  return data;
};

export const totalServicesCost = async (serviceIds) => {
  const { data } = await axiosInstance.get("salon/calculate-total-cost", {
    params: { services_ids: serviceIds },
  });
  return data;
};
